export default __webpack_public_path__ + "static/media/LandingPage (1).895c7d31.svg";